module.exports = __webpack_public_path__ + "img/info.4481362a.png";